export default {"src":"/_next/static/media/hotel.3e0ceba0.svg","height":21,"width":19,"blurWidth":0,"blurHeight":0};